import type { ReactNode } from 'react';

export function AuthLayout({
  eyebrow,
  children,
}: {
  eyebrow?: string;
  children: ReactNode;
}) {
  return (
    <div style={{ display: 'flex', height: '100vh', background: 'var(--ev-bg)' }}>
      {/* Left brand panel */}
      <div
        style={{
          width: '44%',
          background: 'linear-gradient(140deg, #1A1F24 0%, #2A1810 60%, #6E2A07 100%)',
          color: 'white',
          padding: 48,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          position: 'relative',
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        <div style={{ position: 'absolute', top: -100, right: -100, width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(33,111,183,0.18), transparent 70%)' }} />
        <div style={{ position: 'absolute', bottom: -150, left: -50, width: 350, height: 350, borderRadius: '50%', background: 'radial-gradient(circle, rgba(33,111,183,0.10), transparent 70%)' }} />

        {/* Logo */}
        <div style={{ position: 'relative', zIndex: 1, display: 'inline-flex', alignItems: 'center', gap: 10 }}>
          <img
            src="/assets/banesprev-logo.png"
            alt="Banesprev"
            style={{ height: 27, width: 'auto' }}
          />
          <span style={{
            fontSize: 16,
            fontWeight: 500,
            letterSpacing: '0.02em',
            color: 'rgba(255,255,255,0.6)',
            borderLeft: '1px solid rgba(255,255,255,0.2)',
            paddingLeft: 10,
          }}>
            GED
          </span>
        </div>

        {/* Headline */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: '#FFA571',
            marginBottom: 12,
          }}>
            Plataforma de Governança Documental
          </div>
          <h1 style={{
            fontSize: 40,
            lineHeight: 1.1,
            fontWeight: 600,
            letterSpacing: '-0.02em',
            color: 'white',
            margin: '0 0 20px',
            maxWidth: 440,
          }}>
            A memória institucional do seu fundo, em um só lugar.
          </h1>
          <p style={{ fontSize: 15, lineHeight: 1.55, color: 'rgba(255,255,255,0.72)', maxWidth: 440 }}>
            Atas, pareceres, regulamentos e correspondências — organizados por órgão deliberativo, acessíveis com um clique e auditados ponta a ponta.
          </p>
        </div>

        {/* Footer */}
        <div style={{ position: 'relative', zIndex: 1, fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>
          © Banesprev 2026 · Conexão protegida (TLS 1.3) · Conformidade LGPD
        </div>
      </div>

      {/* Right form panel */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32, overflow: 'auto' }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          {eyebrow && (
            <div style={{
              fontSize: 11,
              fontWeight: 600,
              color: 'var(--ev-accent)',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              marginBottom: 12,
            }}>
              {eyebrow}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

export function FieldError({ children }: { children: ReactNode }) {
  return <p className="text-destructive mt-1 text-xs">{children}</p>;
}
